export default __webpack_public_path__ + "74d39f62d8de93ff46eaadd80fccdb78.wav";